import './polyfill';
import './configure-packages';
import './local-dev-handling';

// proceed with regular imports
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary, ErrorPage, LoadingScreen, RootNode } from '@hugendubel/react-basic';
import { OutdatedBrowser } from '@hugendubel/utils';
import { App } from './ui/App';
import { ReactAppInit } from '@hugendubel/react-ws';
import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { BrowserRouter } from 'react-router-dom';
import { SessionKeepAlive } from '@hugendubel/login';

export const init = (): void => {
    LoadingScreen.init();
    ReactAppInit.run()
        .then(() => {
            SessionKeepAlive.run();
            return ReactDOM.render(
                <StrictMode>
                    <ErrorBoundary fallback={ErrorPage}>
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </ErrorBoundary>
                </StrictMode>,
                RootNode.get()
            );
        })
        .catch(e => Track.error(TRACK_ID('2020-11-27 03:06:25'), 'error initializing oauth frontend: ' + e.message));
};

OutdatedBrowser.showFallback() || init();
